import { axios, base } from '../http';

/** 学校集体备课配置 */
export const getPrepSchoolConfig = (params) => {
  return axios.get(`${base}/api/TeachingResearch/GetPrepSchoolConfig`, { params }).then(res => res.data);
};
export const savePrepSchoolConfig = (params) => {
  return axios.post(`${base}/api/TeachingResearch/SavePrepSchoolConfig`, params).then(res => res.data);
};

/** 课本册 */
export const getTextbooks = (params) => {
  return axios.get(`${base}/api/TeachingResearch/GetTextbooks`, { params }).then(res => res.data);
};
export const saveTextbook = (params) => {
  return axios.post(`${base}/api/TeachingResearch/SaveTextbook`, params).then(res => res.data);
};
export const deleteTextbook = (params) => {
  return axios.get(`${base}/api/TeachingResearch/DeleteTextbook`, { params }).then(res => res.data);
};

/** 单元目录（按课本册；仅传 textbookId，不再传 groupId） */
export const getCatalogTree = (params) => {
  const textbookId = params && (params.textbookId != null ? params.textbookId : params.TextbookId);
  return axios
    .get(`${base}/api/TeachingResearch/GetCatalogTree`, { params: { textbookId } })
    .then(res => res.data);
};
export const saveUnit = (params) => {
  return axios.post(`${base}/api/TeachingResearch/SaveUnit`, params).then(res => res.data);
};
export const deleteUnit = (params) => {
  return axios.get(`${base}/api/TeachingResearch/DeleteUnit`, { params }).then(res => res.data);
};
export const saveLesson = (params) => {
  return axios.post(`${base}/api/TeachingResearch/SaveLesson`, params).then(res => res.data);
};
/** 批量生成课时（默认名：单元名+授课N / 单元名+练习课N） */
export const batchGenerateLessons = (params) => {
  return axios.post(`${base}/api/TeachingResearch/BatchGenerateLessons`, params).then(res => res.data);
};
export const deleteLesson = (params) => {
  return axios.get(`${base}/api/TeachingResearch/DeleteLesson`, { params }).then(res => res.data);
};
export const saveUnitAssignments = (params) => {
  return axios.post(`${base}/api/TeachingResearch/SaveUnitAssignments`, params).then(res => res.data);
};
export const downloadCatalogTemplate = () => {
  return axios.get(`${base}/api/TeachingResearch/DownloadCatalogTemplate`, { responseType: 'blob' });
};
export const importCatalogExcel = (textbookId, file) => {
  const form = new FormData();
  form.append('file', file);
  return axios.post(`${base}/api/TeachingResearch/ImportCatalogExcel?textbookId=${textbookId}`, form, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }).then(res => res.data);
};

/** 教案公共库 */
export const getLibraryPage = (params) => {
  return axios.post(`${base}/api/TeachingResearch/GetLibraryPage`, params).then(res => res.data);
};
export const getLibraryDetail = (params) => {
  return axios.get(`${base}/api/TeachingResearch/GetLibraryDetail`, { params }).then(res => res.data);
};
export const adminCloseVote = (params) => {
  return axios.post(`${base}/api/TeachingResearch/AdminCloseVote`, params).then(res => res.data);
};
export const adminPublishToLibrary = (params) => {
  return axios.post(`${base}/api/TeachingResearch/AdminPublishToLibrary`, params).then(res => res.data);
};
export const adminUnpublishFromLibrary = (params) => {
  return axios.post(`${base}/api/TeachingResearch/AdminUnpublishFromLibrary`, params).then(res => res.data);
};
export const transferDocumentOperator = (params) => {
  return axios.post(`${base}/api/TeachingResearch/TransferDocumentOperator`, params).then(res => res.data);
};
export const adminEndDiscussion = (params) => {
  return axios.post(`${base}/api/TeachingResearch/AdminEndDiscussion`, params).then(res => res.data);
};
export const adminBindLessons = (params) => {
  return axios.post(`${base}/api/TeachingResearch/AdminBindLessons`, params).then(res => res.data);
};
export const getGroupTeachers = (params) => {
  return axios.get(`${base}/api/TeachingResearch/GetGroupTeachers`, { params }).then(res => res.data);
};

/** 学校监管看板 */
export const getSuperviseDashboard = (params) => {
  return axios.post(`${base}/api/TeachingResearch/GetSuperviseDashboard`, params).then(res => res.data);
};
export const getSuperviseBlocked = (params) => {
  return axios.post(`${base}/api/TeachingResearch/GetSuperviseBlocked`, params).then(res => res.data);
};
export const getUnitCoverage = (params) => {
  return axios.post(`${base}/api/TeachingResearch/GetUnitCoverage`, params).then(res => res.data);
};
export const getSuperviseExceptions = (params) => {
  return axios.post(`${base}/api/TeachingResearch/GetSuperviseExceptions`, params).then(res => res.data);
};
export const urgePrepDocument = (params) => {
  return axios.post(`${base}/api/TeachingResearch/UrgePrepDocument`, params).then(res => res.data);
};
export const exportUnitCoverageExcel = (params) => {
  return axios.post(`${base}/api/TeachingResearch/ExportUnitCoverageExcel`, params, { responseType: 'blob' });
};
export const exportLibraryExcel = (params) => {
  return axios.post(`${base}/api/TeachingResearch/ExportLibraryExcel`, params, { responseType: 'blob' });
};

export const getTeachingGroupPage = (params) => {
  return axios.post(`${base}/api/TeachingResearch/GetGroupPage`, params).then(res => res.data);
};
// 保存教研组（新增/编辑）

export const saveTeachingGroup = (params) => {
  return axios.post(`${base}/api/TeachingResearch/SaveGroup`, params).then(res => res.data);
};
// 修改教研组状态

export const changeTeachingGroupStatus = (params) => {
  return axios.post(`${base}/api/TeachingResearch/ChangeGroupStatus?id=${params.id}&status=${params.status}`).then(res => res.data);
};
// 删除教研组

export const deleteTeachingGroup = (params) => {
  return axios.get(`${base}/api/TeachingResearch/DeleteGroup`, { params: params }).then(res => res.data);
};
// 获取教研组下拉列表

export const getAllGroups = (params) => {
  return axios.get(`${base}/api/TeachingResearch/GetAllGroups`, { params: params }).then(res => res.data);
};
// 后台分页查询备课文档

export const getPrepDocumentPageForAdmin = (params) => {
  return axios.post(`${base}/api/TeachingResearch/GetDocumentPageForAdmin`, params).then(res => res.data);
};
// 教师教研统计（后台）

export const getTeacherStatistics = (params) => {
  return axios.post(`${base}/api/TeachingResearch/GetTeacherStatistics`, params).then(res => res.data);
};
// 获取教师教研趋势统计（后台）

export const getTeacherTrendStatistics = (params) => {
  return axios.get(`${base}/api/TeachingResearch/GetTeacherTrendStatistics`, { params: params }).then(res => res.data);
};
// 获取备课文档详情（后台）

export const getPrepDocumentDetail = (params) => {
  return axios.get(`${base}/api/TeachingResearch/GetDocumentDetail`, { params: params }).then(res => res.data);
};
// 导出教研组 Excel

export const exportTeachingGroup = (params) => {
  return axios.post(`${base}/api/TeachingResearch/ExportGroupExcel`, params, { responseType: 'blob' });
};
// 导出备课文档 Excel

export const exportPrepDocument = (params) => {
  return axios.post(`${base}/api/TeachingResearch/ExportDocumentExcel`, params, { responseType: 'blob' });
};
// 导出教研统计 Excel

export const exportTeacherStatisticsExcel = (params) => {
  return axios.post(`${base}/api/TeachingResearch/ExportStatisticsExcel`, params, { responseType: 'blob' });
};
// 代调课后台管理统- 获取列表及汇
